import { createContext, useContext } from 'react';
export const DarkModeContext = createContext({ darkMode: false, toggleDark: () => {} });
export const useDarkMode = () => useContext(DarkModeContext).darkMode;
export const useToggleDark = () => useContext(DarkModeContext).toggleDark;
